import { render, staticRenderFns } from "./follow_button.vue?vue&type=template&id=a037d988&scoped=true&"
import script from "./follow_button.vue?vue&type=script&lang=js&"
export * from "./follow_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a037d988",
  null
  
)

export default component.exports